import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const progressBarStyle = style({
  //
});

export const contentStyle = recipe({
  base: {
    padding: theme.spacings.s,
    // flexDirection: "column",
    // gap: theme.spacings.s,
    // ...responsiveContainer({
    //   600: {
    //     flexDirection: "row",
    //     gap: theme.spacings.l,
    //   },
    // }),
  },
  variants: {},
});
